$(function () {
	var data = window.orderReminderCheckout;
	var $form = $('#checkoutForm');
	if (data && $form.length) {
		$form.find('[name]').each(function () {
			if (this.name === 'shipping_method' || this.name === 'payment_method') {
				return;
			}
			if (!Object.prototype.hasOwnProperty.call(data, this.name)) {
				return;
			}
			if (this.type === 'radio') {
				this.checked = this.value === data[this.name];
			} else if (this.type === 'checkbox') {
				this.checked = !!data[this.name];
			} else {
				$(this).val(data[this.name] || '');
			}
		});
		['gls', 'foxpost'].forEach(function (provider) {
			$('#' + provider + 'PickupName').text(data[provider + '_parcelshop_name'] || '');
			$('#' + provider + 'PickupAddress').text(data[provider + '_parcelshop_address'] || '');
		});
	}

	var element = document.getElementById('orderReminderModal');
	if (!element) {
		return;
	}
	var modal = new window.bootstrap.Modal(element);
	modal.show();
	var lang = window.orderReminderLang;
	$('#orderReminderForm').on('submit', function (event) {
		event.preventDefault();
		var input = document.getElementById('orderReminderDays');
		var $message = $('#orderReminderMessage').removeClass('text-success').addClass('text-danger');
		if (!input.checkValidity()) {
			$message.text(lang.invalid_days);
			input.reportValidity();
			return;
		}
		var $button = $(this).find('[type="submit"]').prop('disabled', true);
		$.ajax({
			url: element.dataset.url,
			method: 'POST',
			data: $(this).serialize(),
			success: function (response) {
				$message.removeClass('text-danger').addClass('text-success').text(response.message);
				$('#orderReminderDays').prop('disabled', true);
			},
			error: function (xhr) {
				var response = xhr.responseJSON;
				$message.text(response && response.errors && response.errors.days
					? response.errors.days[0] : (response && response.message) || lang.failed);
				$button.prop('disabled', false);
			}
		});
	});
});
